import request from "@/utils/http"
import store from "@/store"

export function createTask({
  name,
  description,
  groupId, // 任务分组ID
  parentId, // 父任务ID
  projectId,
  typeId, // 任务模板ID
  priority = 0, // 0,1,2,3 数字越大越紧急
  assignee, // 用户ID 负责人
  assigneeRole, // 角色ID 负责角色
  dueDate,
  startAt,
  children,
  attachmentIds
}) {
  return request
    .post("/task/createTask", {
      name,
      description,
      groupId,
      parentId,
      projectId,
      typeId,
      priority,
      assignee,
      assigneeRole,
      dueDate,
      startAt,
      children,
      attachmentIds
    })
    .commonDeal()
}

export function updateTask(
  {
    projectId,
    name,
    description,
    groupId,
    priority = 0,
    startAt,
    dueDate,
    assignee,
    assigneeRole,
    parentId,
    children,
    attachmentIds
  },
  taskId
) {
  return request
    .post(
      "/task/updateTask",
      {
        projectId,
        name,
        description,
        groupId,
        priority,
        startAt,
        dueDate,
        assignee,
        assigneeRole,
        parentId,
        children,
        attachmentIds
      },
      { params: { taskId } }
    )
    .commonDeal()
}

export function deleteTask(taskIds) {
  return request.post("/task/deleteTask", taskIds).commonDeal()
}

export function updatePrevTask(taskId, prevTaskId, isAdd = true) {
  return request
    .post("/task/updatePrevTask", null, { params: { taskId, prevTaskId, isAdd } })
    .commonDeal()
}

/**
 * 完成任务
 * @param taskId
 * @param sheetData 完成时候填充的工作表数据(任务成果/逾期原因)
 * @param saveOnly 是否是仅临时保存任务成果
 * @returns {*}
 */
export function completeTask(taskId, sheetData = {}, saveOnly = false) {
  return request
    .post("/task/completeTask", sheetData, { params: { taskId, saveOnly } })
    .commonDeal()
}

export function redoTask(taskId) {
  return request.post("/task/redoTask", null, { params: { taskId } }).commonDeal()
}

export function getTask(taskId) {
  return request.get("/task/getTask", { params: { taskId } }).commonDeal()
}

export function getTaskList({
  name = null,
  status = null,
  assignee = null,
  assigneeRole = null,
  startAt = null,
  dueDate = null,
  completeAt = null,
  timeoutDay = null,
  priority = null,
  description = null,
  listType, // ALL,TODAY,RUNNING,COMPLETED,TIMEOUT,UNASSIGNED等
  groupId,
  projectId,
  ignoreTaskId,
  sortBy,
  direction,
  page = 0,
  size = 20
}) {
  return request
    .post("/task/getTaskList", {
      name,
      status,
      assignee,
      assigneeRole,
      startAt,
      dueDate,
      completeAt,
      timeoutDay,
      priority,
      description,
      listType,
      groupId,
      projectId,
      ignoreTaskId,
      sortBy,
      direction,
      page,
      size
    })
    .commonDeal()
}

export function getTaskLogList(taskId) {
  return request.get("/task/getTaskLogList", { params: { taskId } }).commonDeal()
}

export function createTaskGroup({ name, projectId }) {
  return request.post("/task/createTaskGroup", { name, projectId }).commonDeal()
}

export function updateTaskGroup({ name, projectId }, groupId) {
  return request
    .post("/task/updateTaskGroup", { name, projectId }, { params: { groupId } })
    .commonDeal()
}

export function deleteTaskGroup(taskGroupId) {
  return request.post("/task/deleteTaskGroup", null, { params: { taskGroupId } }).commonDeal()
}

export function setTaskGroupOrder(taskGroupIds, projectId) {
  return request
    .post("/task/setTaskGroupOrder", taskGroupIds, { params: { projectId } })
    .commonDeal()
}

export function getTaskGroupList(projectId) {
  return request.get("/task/getTaskGroupList", { params: { projectId } }).commonDeal()
}

export function getTaskNoticeList(projectId) {
  return request.get("/task/getTaskNoticeList", { params: { projectId } }).commonDeal()
}

export function getTaskNotice(noticeId) {
  return request.get("/task/getTaskNotice", { params: { noticeId } })
}

export function createTaskNotice({ rule, timeFrame, userType, noticeType, projectId }) {
  return request
    .post("/task/createTaskNotice", { rule, timeFrame, userType, noticeType, projectId })
    .commonDeal()
}

export function updateTaskNotice({ rule, timeFrame, userType, noticeType, projectId }, noticeId) {
  return request
    .post(
      "/task/updateTaskNotice",
      { rule, timeFrame, userType, noticeType, projectId },
      { params: { noticeId } }
    )
    .commonDeal()
}

export function deleteTaskNotice(noticeId) {
  return request.post("/task/deleteTaskNotice", null, { params: { noticeId } }).commonDeal()
}

/**
 * 批量添加参与人
 * @param taskIds
 * @param userIds
 * @returns {*}
 */
export function addParticipant(taskIds, userIds, roleIds) {
  return request.post("/task/addParticipant", { taskIds, userIds, roleIds }).commonDeal()
}

export function updateParticipants(taskId, userIds, roleIds) {
  return request
    .post("/task/updateParticipants", { userIds, roleIds }, { params: { taskId } })
    .commonDeal()
}

export function updateOwner(taskIds, newOwnerId, partFlag = true) {
  return request
    .post(`/task/updateOwner`, taskIds, { params: { newOwnerId, partFlag } })
    .commonDeal()
}

// 批量更新负责角色
export function updateAssignRoles(taskIds, assignRole) {
  return request.post(`/task/updateAssignRoles`, taskIds, { params: { assignRole } }).commonDeal()
}

export function changeTaskParent(taskIds, parentId) {
  return request.post(`/task/changeTaskParent`, taskIds, { params: { parentId } }).commonDeal()
}

/**
 * 递归修改任务分组
 * @param taskIds 任务ID,注意:当taskIds中包含父子任务时,只应传入父任务ID
 * @param groupId
 * @returns {*}
 */
export function changeTaskGroup(taskIds, groupId) {
  return request.post(`/task/changeTaskGroup`, taskIds, { params: { groupId } }).commonDeal()
}

export function getVerifyRecordListByTaskId(taskId) {
  return request.get(`/sheet/getVerifyRecordListByTaskId`, { params: { taskId } }).commonDeal()
}

export function getVerifyProcessesByTaskId(taskId) {
  return request.get(`/sheet/getVerifyProcessesByTaskId`, { params: { taskId } }).commonDeal()
}

export function getVerifyProcessesBySheetDataId(sheetDataId, running) {
  if (store.getters.isTemplateMode) {
    return Promise.resolve([])
  }
  return request
    .get(`/sheet/getVerifyProcessesBySheetDataId`, { params: { sheetDataId, running } })
    .commonDeal()
}

/**
 * 标记为里程碑/取消里程碑
 * @param {String} taskId
 * @param {Boolean} set
 */
export function setTaskMilestone(taskId, set) {
  return request.post(`/task/setTaskMilestone`, null, { params: { taskId, set } }).commonDeal()
}

/**
 * 设置风险
 */
export function setTaskRisk(taskId, riskSet, riskLevel, copingPlan, attachmentIds, description) {
  return request
    .post(
      `/task/setTaskRisk`,
      {
        taskId,
        riskSet,
        riskLevel,
        copingPlan,
        attachmentIds,
        description
      },
      { params: { taskId } }
    )
    .commonDeal()
}

export function batchSetTaskMilestone(taskIds, set) {
  return request.post(`/task/batch/setTaskMilestone`, taskIds, { params: { set } }).commonDeal()
}

// 批量设置风险
export function batchSetTaskRisk(taskIds, riskSet) {
  return request.post(`/task/batch/setTaskRisk`, taskIds, { params: { riskSet } }).commonDeal()
}

export function batchUpdate(taskIds, property, value) {
  return request
    .post(`/task/batch/updateTasks`, taskIds, { params: { property, value } })
    .commonDeal()
}

export function setTaskPublicMode(taskId, set) {
  return request.post(`/task/setTaskPublicMode`, null, { params: { taskId, set } }).commonDeal()
}
